<template>
    <div class="card shadow-sm mb-5 p-5 card-flush ">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
        <div class="card-title">
            <h5 style="text-align: start">{{ title }}</h5>
        </div>
        <div class="card-toolbar">
            <ButtonDropdownFilter
                :btn-title="$t('crm.pipeline.opportunities')"
                :options="opportunties"
                value-field="id"
                name-field="name"
                v-model="query.opportunity_id"
                :border="true"
            />
            <ButtonDropdownFilter
                :btn-title="$t('label.allSellers')"
                :options="salesPersons"
                value-field="id"
                name-field="fullname"
                v-model="query.seller_id"
                :border="true"
            />

        </div> 
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-show="!getOpportunitiesCountByActivityType?.length" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
            <div v-show="getOpportunitiesCountByActivityType?.length" class="p-5 position-relative">
              <canvas id="kt_chartjs_moyen_activity" class="mh-400px"></canvas>
              <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; height: 50%; top: 45%; left: 50%; transform: translate(-50%, -50%);">
                <div class="text-center">
                  <h1 class="display-5">{{opportunitiesCountByActivityType[0]?.count}}</h1>
                  <span>{{$t('pipelines.activities')}}</span>
                </div>
              </div>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import ButtonDropdownFilter from '@/components/ButtonDropdownFilter.vue';
import Loader from '@/components/Loader.vue';
import { computed, watch, onMounted, shallowRef, ref, nextTick} from 'vue';
import { useStore } from 'vuex';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },
})
  
const query = ref({
    start_date: '',
    end_date: '',
    opportunity_id: '',
    seller_id: '',
    status: 'WON'
})

const online = ref(false)
const getOpportunitiesCountByActivityType = ref([])
const opportunitiesCountByActivityType = ref(0)
const chartMoyenActivityRef = shallowRef(null)

const salesPersons = computed(() => store.getters['pipelines/getSalesPersons'])
const opportunties = computed(() => store.getters['pipelines/getPipelines'])

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

watch(() => online.value, (value) => {
    query.value.status = value ? 'LOST' : 'WON'
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  
    Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, opportunity_id: query.value.opportunity_id, seller_id: query.value.seller_id, status: query.value.status}).then((res) => {
          let answer = res.response?.data || res?.data

          /* getOpportunitiesCountByActivityType.value = Object.values(answer?.getOpportunitiesCountByActivityType).filter(item => item.name !== 'global_total');
          opportunitiesCountByActivityType.value = Object.values(answer?.getOpportunitiesCountByActivityType).filter(item => item.name == 'global_total'); */
        }),
        store.dispatch('pipelines/loadPipelines'),
        store.dispatch('pipelines/loadSalesPersons')
    ]).then(() => {
      chartMoyenActivity()
    })
}

function chartMoyenActivity(){
    let names = [];
    let counts = [];
    let colors = ['#0072CE66', '#E51335', '#F07817', '#646E7B', '#0072CE', '#024983'];
  
    getOpportunitiesCountByActivityType.value?.forEach(item => {
      if (item.count > 0) { 
        names.push(item.name)
        counts.push(item.count)
      }
    })
  
    if(names.length === 0 || counts.length === 0 || colors.length === 0){
      getOpportunitiesCountByActivityType.value = [];
    }
  
    let ctx = document.getElementById('kt_chartjs_moyen_activity');
  
    if (ctx) {
      if(Chart.getChart("kt_chartjs_moyen_activity")) {
        Chart.getChart("kt_chartjs_moyen_activity")?.destroy()
      }
      
      let context = ctx.getContext('2d');
      let fontFamily = KTUtil.getCssVariableValue('--bs-font-sans-serif');
  
      let data = {
          labels: names,
          datasets: [{
            data: counts,
            backgroundColor: colors,
            hoverOffset: 10
        }]
      };
  
      let config = {
          type: 'doughnut',
          data: data,
          options: {
            plugins: {
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltip: {
                    callbacks: {
                        label: function(context) {
                          let percentageLabel = i18n.global.t('pipelines.opportunity_number');
                            return `${percentageLabel}: ${$formatLocalAmount(context.parsed)}`;
                        }
                    }
                }
            },
            responsive: true,
            elements: {
              arc: {
                  borderWidth: 1 
              }
            },
            cutout: '40%'
          },
          defaults:{
              global: {
                  defaultFont: fontFamily
              }
          }
      };
  
      if (!chartMoyenActivityRef.value) {
        chartMoyenActivityRef.value = new Chart(ctx, config);
      }else{
        chartMoyenActivityRef.value.destroy()
        chartMoyenActivityRef.value = new Chart(ctx, config);
      }
    } else {
      console.error('Canvas element not found');
      return;
    }
  }

onMounted(() => {
  if(props.start) query.value.start_date = props.start
  if(props.end) query.value.end_date = props.end
})
</script>